import { create } from "zustand";

export const statusModalStore = create((set) => ({
  isOpen: false,
  title: "",
  subtitle: "",
  statusType: "success", // success | warning | error
  action: null,
  actionText: "",

  showModal: ({
    title,
    subtitle,
    statusType = "success",
    action = null,
    actionText = "",
  }) => set({ isOpen: true, title, subtitle, statusType, action, actionText }),

  closeModal: () =>
    set({
      isOpen: false,
      title: "",
      subtitle: "",
      statusType: "",
      action: null,
      actionText: "",
    }),
}));
